import { MAX_CELL_WIDTH } from "ds/components/Table/constants";
import { TableColumnMeta } from "ds/components/Table/types";

export enum STACK_TASKS_COLUMN_ID {
  STATUS = "STATUS",
  COMMAND = "COMMAND",
  TRIGGERED_BY = "TRIGGERED_BY",
  COMMIT = "COMMIT",
  STARTED_AT = "STARTED_AT",
  ROW_ACTIONS = "ROW_ACTIONS",
}

export const STACK_TASKS_TABLE_STORAGE_KEY = "stackTasksColumnsConfig";

export const STACK_TASKS_TABLE_COLUMNS_CONFIG: Record<STACK_TASKS_COLUMN_ID, TableColumnMeta> = {
  [STACK_TASKS_COLUMN_ID.STATUS]: {
    id: STACK_TASKS_COLUMN_ID.STATUS,
    title: "Status",
    minWidth: 150,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [STACK_TASKS_COLUMN_ID.COMMAND]: {
    id: STACK_TASKS_COLUMN_ID.COMMAND,
    title: "Command",
    minWidth: 150,
    defaultWidth: 465,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: false,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [STACK_TASKS_COLUMN_ID.TRIGGERED_BY]: {
    id: STACK_TASKS_COLUMN_ID.TRIGGERED_BY,
    title: "Triggered by",
    minWidth: 170,
    defaultWidth: 240,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [STACK_TASKS_COLUMN_ID.COMMIT]: {
    id: STACK_TASKS_COLUMN_ID.COMMIT,
    title: "Commit",
    minWidth: 110,
    defaultWidth: 140,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [STACK_TASKS_COLUMN_ID.STARTED_AT]: {
    id: STACK_TASKS_COLUMN_ID.STARTED_AT,
    title: "Started at",
    minWidth: 150,
    defaultWidth: 240,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [STACK_TASKS_COLUMN_ID.ROW_ACTIONS]: {
    id: STACK_TASKS_COLUMN_ID.ROW_ACTIONS,
    title: "Task actions",
    noHeader: true,
    minWidth: 127,
    defaultWidth: 127,
    maxWidth: 127,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
};

export const STACK_TASKS_SORT_CONFIG: Record<string, string> = {
  [STACK_TASKS_COLUMN_ID.STATUS]: "state",
  [STACK_TASKS_COLUMN_ID.TRIGGERED_BY]: "triggeredBy",
  [STACK_TASKS_COLUMN_ID.STARTED_AT]: "createdAt",
};
